module.exports = __webpack_public_path__ + "img/icon_waku_manual.b31e4b76.png";